import {AiEngineTypeId, AiEngineTypes, AIGamesRecommendations} from "../ai-recommendations-reader.service.interface";
import {GamesRecommendationsBaseModel} from "./games-recommendations-base.model";
import {LocalStorageKeys} from "../../storage/local-storage-keys";

export class RecentlyAddedGamesRecommendationsModel extends GamesRecommendationsBaseModel {
    protected get localStorageKey(): string {
        return LocalStorageKeys.aiRecentlyAddedGamesRecommendations;
    }

    protected async _readGamesRecommendationsFromServer(): Promise<AIGamesRecommendations> {
        const response = await this.services.api.insightController.getRecentlyAddedGamesRecommendationsForPlayer({
            engineType: AiEngineTypeId[AiEngineTypes.ML888],
        });

        return {
            engine: AiEngineTypes.ML888,
            gameTypes: response.GameTypes ?? []
        }
    }


}